import React, { useState } from "react";

import { Box, SxProps, Theme } from "@mui/material";

import { theme } from "@/src/theme/theme";

// Replicates the previous `mui-image` <Image duration={250} /> behaviour with
// a plain MUI <Box component="img">:
//   - image stays invisible until onLoad, then fades opacity 0 -> 1 over
//     `duration / 2 = 125ms` with easing `cubic-bezier(0.7, 0, 0.6, 1)`;
//   - on load it plays the `materialize` keyframe animation over the full
//     `duration = 250ms` (saturate / contrast / brightness settle-in);
//   - `objectFit: "cover"`, `width/height: 100%`, `zIndex: 4` on the img;
//   - outer Box: flex-center, `position: relative`, `width: 100%`,
//     `backgroundColor: theme.palette.misc.timelineBackground`.
export interface VehicleImageProps {
  imageUrl?: string;
  sx?: SxProps<Theme>;
}

const FADE_DURATION_MS = 250;
const OPACITY_DURATION_MS = FADE_DURATION_MS / 2;
const EASING = "cubic-bezier(0.7, 0, 0.6, 1)";

const VehicleImage = (props: VehicleImageProps) => {
  const { imageUrl, sx } = props;
  const [loaded, setLoaded] = useState(false);

  return (
    <Box
      sx={[
        {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          width: "100%",
          backgroundColor: theme.palette.misc.timelineBackground
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      {imageUrl && (
        <Box
          component="img"
          src={imageUrl}
          alt=""
          onLoad={() => setLoaded(true)}
          sx={{
            "@keyframes vehicleImageMaterialize": {
              "0%": {
                filter: "saturate(20%) contrast(50%) brightness(120%)"
              },
              "75%": {
                filter: "saturate(60%) contrast(100%) brightness(100%)"
              },
              "100%": {
                filter: "saturate(100%) contrast(100%) brightness(100%)"
              }
            },
            zIndex: 4,
            position: "relative",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loaded ? 1 : 0,
            transition: `opacity ${OPACITY_DURATION_MS}ms ${EASING}`,
            animation: loaded
              ? `vehicleImageMaterialize ${FADE_DURATION_MS}ms 1 ${EASING}`
              : "none"
          }}
        />
      )}
    </Box>
  );
};

export default VehicleImage;
